import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {CompanyInsuranceCarrier} from 'main/stores/benefits';
import {AdminContact} from 'main/stores/users';
import {calendarDate} from 'shared/tools';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';
import _ from 'lodash';

class Company extends DomainObject {
  name;
  phoneNumber;
  payrollEnabled;
  managedPayroll;
  syncedPayroll;
  orgChartEnabled;
  jazzHRApiKey;
  greenhouseApiKey;
  bankingEnabled;
  sinEnabled;
  ssoEnabled;
  ssoProviderName;
  mfaSmsEnabled;
  mfaAuthenticatorEnabled;
  companyInsuranceCarriers = [];
  adminContacts = [];
  employeeAnnouncementsEnabled;
  slackEnabled;
  showPTOCalendarType;

  status;
  nextRenewalDate;
  allowsImpersonation = false;
  enrolmentsCount;

  maxUnconditionalEligibilityAge;
  maxConditionalEligibilityAge;
  maxQcConditionalEligibilityAge;

  birthdayCelebrationVisibility;
  startDateCelebrationVisibility;
  anniversaryCelebrationVisibility;
  staffCountVisibility;
  peopleOffTodayVisibility;

  logo;
  platformColor;

  broker;

  _relations = {
    _dates: ['nextRenewalDate'],
    companyInsuranceCarriers: [CompanyInsuranceCarrier],
    logo: AttachedDocument,
    adminContacts: [AdminContact]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      phoneNumber: observable,
      payrollEnabled: observable,
      managedPayroll: observable,
      syncedPayroll: observable,
      orgChartEnabled: observable,
      jazzHRApiKey: observable,
      greenhouseApiKey: observable,
      bankingEnabled: observable,
      sinEnabled: observable,
      ssoEnabled: observable,
      ssoProviderName: observable,
      mfaSmsEnabled: observable,
      mfaAuthenticatorEnabled: observable,
      companyInsuranceCarriers: observable,
      adminContacts: observable,
      employeeAnnouncementsEnabled: observable,
      slackEnabled: observable,
      showPTOCalendarType: observable,
      status: observable,
      nextRenewalDate: observable,
      allowsImpersonation: observable,
      enrolmentsCount: observable,
      maxUnconditionalEligibilityAge: observable,
      maxConditionalEligibilityAge: observable,
      maxQcConditionalEligibilityAge: observable,
      birthdayCelebrationVisibility: observable,
      startDateCelebrationVisibility: observable,
      anniversaryCelebrationVisibility: observable,
      staffCountVisibility: observable,
      peopleOffTodayVisibility: observable,
      logo: observable,
      platformColor: observable,
      broker: observable,
      nextRenewalDateView: computed,
      awaitingLaunch: computed,
      logoUrl: computed
    });

    this.merge(other);
  }

  get nextRenewalDateView() {
    return calendarDate(this.nextRenewalDate);
  }

  get awaitingLaunch() {
    return this.status === 'awaiting_launch';
  }

  get logoUrl() {
    return _.get(this, 'links.logo');
  }
}

export default Company;
